/**
* SEO Block JS
* -----------------------------------------------------------------------------
*
* All the JS for the SEO Block component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'seo-block',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.seo-block-marquee__splide' ).each( function( key, component ) {
        const list = component.querySelector( '.splide__list' );
        const slides = Array.from( list.children );
        const windowWidth = window.innerWidth;

        // Clone slides until list width is at least 2x the window width
        function duplicateSlides() {
          let totalWidth = list.scrollWidth;
          while ( totalWidth < windowWidth * 2 ) {
            slides.forEach( ( slide ) => {
              list.appendChild( slide.cloneNode( true ) );
            } );
            totalWidth = list.scrollWidth;
          }
        }

        duplicateSlides();

        new Splide( component, {
          type: 'loop',
          autoWidth: true,
          gap: '2rem',
          arrows: false,
          pagination: false,
          drag: false,
          flickPower: 0,
          autoScroll: {
            speed: 0.75,
            pauseOnHover: false,
            pauseOnFocus: false,
            rewind: false,
          },
        } ).mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'seo-block', COMPONENT );
} )( app );
